export default {
    username: 'Username',
    usernamePlaceHolder: 'Enter your username',
    password: 'Password',
    passwordPlaceHolder: 'Password',
    login: 'Log in',
    forgotPassword: 'Forgot password?',
    usernameRequired: 'Username is required',
    passwordRequired: 'Password is required'
}
